var _defs, _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path4, _path5, _path6, _path7, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _path8, _path9, _path10, _path11, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _path12, _path13, _path14, _path15, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _path36, _path37, _rect56, _rect57, _rect58, _path38, _rect59, _rect60, _path39, _path40, _polygon, _polygon2, _path41, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _rect61, _polygon10, _rect62, _rect63, _rect64, _rect65, _rect66, _polygon11, _rect67, _path42, _path43, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _path44, _path45, _polygon12, _rect77, _rect78, _rect79, _rect80, _rect81, _polygon13, _rect82, _path46, _rect83, _rect84, _rect85, _rect86, _rect87, _path47, _path48, _rect88, _polygon14, _polygon15, _rect89, _rect90, _rect91, _rect92, _rect93, _path49, _path50, _path51, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _path52, _path53, _path54, _path55, _circle, _circle2, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSalesA(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_Layer_",
    "data-name": "<Layer>",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2452.29 1360.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ebf3fa;}.cls-2{fill:#ffb93e;}.cls-3{fill:#ffa412;}.cls-4{fill:#82b378;}.cls-19,.cls-5{fill:#e2810e;}.cls-6{fill:#ffb27d;}.cls-7{fill:#ed975d;}.cls-8{fill:#a9453d;}.cls-9{fill:#2c3a64;}.cls-10{fill:#2b478b;}.cls-11{fill:#233862;}.cls-12{fill:#1e3d70;}.cls-13{fill:#2a4e96;}.cls-14,.cls-15{fill:#ed9f4a;}.cls-14{opacity:0.2;}.cls-15{opacity:0.6;}.cls-16{fill:#f9ddbf;}.cls-17{fill:#f1a34f;}.cls-18{fill:#e5c1a1;}.cls-19{opacity:0.5;}.cls-20{fill:#ed985f;}.cls-21{fill:#ed7d2b;}.cls-22{fill:#f99746;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M434.12,1500s-301.3-323.49-51-673.72c222.12-310.74,481.09-289.5,671.09-163.4,80.92,53.71,314.23,6.62,512.81-309.57C1837.86-77.93,2776.57,183.6,2605.42,847c-82.83,321,252.07,332.71,81.43,653.63Z",
    transform: "translate(-283.73 -142.21)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1858.16,1154.94l23.11,3.8a9.88,9.88,0,0,1,4.76,2.16,8.18,8.18,0,0,1,2.72,4.2,6.42,6.42,0,0,1,.23,1.51,6.54,6.54,0,0,1-.09,1.39l-53.17,322.25c-.68,4.16-5,7-9.73,6.4l-.46-.06-23.11-3.8-.46-.09c-4.65-1-7.85-5-7.16-9.17L1848,1161.27a6.91,6.91,0,0,1,.37-1.35,7.16,7.16,0,0,1,.69-1.35,8.26,8.26,0,0,1,3.94-3.11A9.88,9.88,0,0,1,1858.16,1154.94Z",
    transform: "translate(-283.73 -142.21)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1864.07,1318.45l-28.49,172.64c-.61,3.71-4.87,6.14-9.59,5.56l-.46-.06-23.11-3.8-.46-.09c-4.65-1-7.91-4.63-7.3-8.34l25-151.44C1832.09,1332.48,1849.69,1329.59,1864.07,1318.45Z",
    transform: "translate(-283.73 -142.21)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1861.09,
    y: 1177.15,
    width: 3.71,
    height: 41.47,
    transform: "translate(93.59 2698.37) rotate(-80.62)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1859.04,
    y: 1189.55,
    width: 3.71,
    height: 41.47,
    transform: "matrix(0.16, -0.99, 0.99, 0.16, 80.43, 2707.44)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1856.59,
    y: 1204.41,
    width: 3.71,
    height: 41.47,
    transform: "translate(63.25 2717.04) rotate(-80.63)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1852.83,
    y: 1227.2,
    width: 3.71,
    height: 41.47,
    transform: "translate(37.73 2732.52) rotate(-80.63)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1848.86,
    y: 1251.3,
    width: 3.71,
    height: 41.47,
    transform: "translate(10.58 2748.73) rotate(-80.63)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1842.76,
    y: 1288.24,
    width: 3.71,
    height: 41.47,
    transform: "matrix(0.16, -0.99, 0.99, 0.16, -30.61, 2773.99)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1837.05,
    y: 1322.83,
    width: 3.71,
    height: 41.47,
    transform: "translate(-70.27 2796.57) rotate(-80.62)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1831.96,
    y: 1353.72,
    width: 3.71,
    height: 41.47,
    transform: "translate(-104.58 2817.84) rotate(-80.63)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1863.04,
    y: 1165.35,
    width: 3.71,
    height: 41.47,
    transform: "matrix(0.16, -0.99, 0.99, 0.16, 107.62, 2691.09)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1864.32,
    y: 1157.55,
    width: 3.71,
    height: 41.47,
    transform: "translate(116.03 2685.5) rotate(-80.63)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1865.57,
    y: 1150.02,
    width: 3.71,
    height: 41.47,
    transform: "matrix(0.16, -0.99, 0.99, 0.16, 124.86, 2680.75)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1847.59,1163.56l40.93,6.73.37-2.29a6.54,6.54,0,0,0,.09-1.39l-40.64-6.69a6.91,6.91,0,0,0-.37,1.35Z",
    transform: "translate(-283.73 -142.21)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1849,1158.57l39.72,6.53a8.18,8.18,0,0,0-2.72-4.2l-33.06-5.44A8.26,8.26,0,0,0,1849,1158.57Z",
    transform: "translate(-283.73 -142.21)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1900.09,1154.94l23.11,3.8a9.81,9.81,0,0,1,4.75,2.16,8.2,8.2,0,0,1,2.73,4.2,7,7,0,0,1,.22,1.51,6.53,6.53,0,0,1-.08,1.39l-53.17,322.25c-.69,4.16-5,7-9.74,6.4l-.45-.06-23.12-3.8-.45-.09c-4.65-1-7.85-5-7.17-9.17l53.17-322.26a7.69,7.69,0,0,1,.37-1.35,6.66,6.66,0,0,1,.7-1.35,8.19,8.19,0,0,1,3.93-3.11A9.93,9.93,0,0,1,1900.09,1154.94Z",
    transform: "translate(-283.73 -142.21)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1906,1318.45l-28.49,172.64c-.61,3.71-4.88,6.14-9.6,5.56l-.45-.06-23.12-3.8-.45-.09c-4.66-1-7.92-4.63-7.3-8.34l25-151.44C1874,1332.48,1891.61,1329.59,1906,1318.45Z",
    transform: "translate(-283.73 -142.21)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1903.02,
    y: 1177.15,
    width: 3.71,
    height: 41.47,
    transform: "translate(128.68 2739.73) rotate(-80.62)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1900.97,
    y: 1189.55,
    width: 3.71,
    height: 41.47,
    transform: "translate(115.59 2748.85) rotate(-80.64)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1898.52,
    y: 1204.41,
    width: 3.71,
    height: 41.47,
    transform: "translate(98.34 2758.41) rotate(-80.63)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1894.76,
    y: 1227.2,
    width: 3.71,
    height: 41.47,
    transform: "translate(72.79 2773.84) rotate(-80.63)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1890.78,
    y: 1251.3,
    width: 3.71,
    height: 41.47,
    transform: "translate(45.68 2790.09) rotate(-80.63)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1884.69,
    y: 1288.24,
    width: 3.71,
    height: 41.47,
    transform: "translate(4.06 2814.94) rotate(-80.63)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1878.98,
    y: 1322.83,
    width: 3.71,
    height: 41.47,
    transform: "translate(-34.79 2838.33) rotate(-80.63)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1873.88,
    y: 1353.72,
    width: 3.71,
    height: 41.47,
    transform: "translate(-69.52 2859.16) rotate(-80.63)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1904.96,
    y: 1165.35,
    width: 3.71,
    height: 41.47,
    transform: "translate(142.28 2732.06) rotate(-80.63)"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1906.25,
    y: 1157.55,
    width: 3.71,
    height: 41.47,
    transform: "translate(151.58 2727.26) rotate(-80.64)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1907.49,
    y: 1150.02,
    width: 3.71,
    height: 41.47,
    transform: "translate(159.97 2722.12) rotate(-80.64)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1889.52,1163.56l40.92,6.73.38-2.29a6.53,6.53,0,0,0,.08-1.39l-40.64-6.69a7.69,7.69,0,0,0-.37,1.35Z",
    transform: "translate(-283.73 -142.21)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1891,1158.57l39.72,6.53a8.2,8.2,0,0,0-2.73-4.2l-33.06-5.44A8.19,8.19,0,0,0,1891,1158.57Z",
    transform: "translate(-283.73 -142.21)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1746.76,1464.31l0,23.42a9.81,9.81,0,0,1-1.36,5,8.33,8.33,0,0,1-3.72,3.37,6.62,6.62,0,0,1-1.45.46,7,7,0,0,1-1.39.14l-326.61-.78c-4.21,0-7.67-3.83-7.87-8.58,0-.15,0-.31,0-.46l0-23.42c0-.16,0-.31,0-.47.22-4.75,3.7-8.55,7.91-8.54l326.61.78a7.12,7.12,0,0,1,1.39.14,6.56,6.56,0,0,1,1.44.47,8.24,8.24,0,0,1,3.71,3.39A9.8,9.8,0,0,1,1746.76,1464.31Z",
    transform: "translate(-283.73 -142.21)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1586.32,1496.38l-175-.42c-3.76,0-6.85-3.83-7-8.58,0-.15,0-.31,0-.46l0-23.42c0-.16,0-.31,0-.47.2-4.75,3.3-8.55,7.06-8.54l153.49.36C1567.34,1467.07,1573,1484,1586.32,1496.38Z",
    transform: "translate(-283.73 -142.21)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1684.41,
    y: 1474.07,
    width: 41.47,
    height: 3.71,
    transform: "matrix(0, -1, 1, 0, -58.55, 3035.35)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1671.84,
    y: 1474.04,
    width: 41.47,
    height: 3.71,
    transform: "matrix(0, -1, 1, 0, -71.06, 3022.76)"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1656.77,
    y: 1474,
    width: 41.47,
    height: 3.71,
    transform: "translate(-86.5 3007.26) rotate(-89.85)"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1633.68,
    y: 1473.95,
    width: 41.47,
    height: 3.71,
    transform: "translate(-109 2984.54) rotate(-89.87)"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1609.25,
    y: 1473.89,
    width: 41.47,
    height: 3.71,
    transform: "matrix(0, -1, 1, 0, -133.35, 2960.02)"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1571.81,
    y: 1473.8,
    width: 41.47,
    height: 3.71,
    transform: "matrix(0, -1, 1, 0, -170.61, 2922.49)"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1536.75,
    y: 1473.72,
    width: 41.47,
    height: 3.71,
    transform: "translate(-205.5 2887.35) rotate(-89.86)"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1505.45,
    y: 1473.64,
    width: 41.47,
    height: 3.71,
    transform: "translate(-237.03 2855.62) rotate(-89.85)"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1696.37,
    y: 1474.1,
    width: 41.47,
    height: 3.71,
    transform: "translate(-46.65 3047.34) rotate(-89.86)"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1704.27,
    y: 1474.11,
    width: 41.47,
    height: 3.71,
    transform: "translate(-38.32 3055.66) rotate(-89.88)"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1711.9,
    y: 1474.13,
    width: 41.47,
    height: 3.71,
    transform: "matrix(0, -1, 1, 0, -31.19, 3062.91)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1736.56,1455.26l-.08,41.47h2.32a7,7,0,0,0,1.39-.14l.08-41.19a7.12,7.12,0,0,0-1.39-.14Z",
    transform: "translate(-283.73 -142.21)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1741.71,1455.88l-.07,40.26a8.33,8.33,0,0,0,3.72-3.37l.06-33.5A8.24,8.24,0,0,0,1741.71,1455.88Z",
    transform: "translate(-283.73 -142.21)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1711.92,1422.75l0,23.42a9.91,9.91,0,0,1-1.37,5,8.19,8.19,0,0,1-3.71,3.37,6.79,6.79,0,0,1-1.45.46,7.12,7.12,0,0,1-1.39.14l-326.61-.77c-4.21,0-7.67-3.83-7.88-8.58,0-.16,0-.31,0-.47l0-23.42c0-.15,0-.31,0-.46.22-4.75,3.69-8.56,7.9-8.55l326.61.78.63,0,.26,0,.3,0,.21,0a6.71,6.71,0,0,1,1.44.46l.21.1.2.1.39.22.23.15a1.37,1.37,0,0,1,.2.13l.37.27.41.35.3.28,0,0,.2.21c.2.21.39.44.57.67l.16.21.15.22.29.46A9.86,9.86,0,0,1,1711.92,1422.75Z",
    transform: "translate(-283.73 -142.21)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1551.48,1454.82l-175-.41c-3.76,0-6.85-3.83-7-8.58,0-.16,0-.31,0-.47l0-23.42c0-.15,0-.31,0-.46.2-4.75,3.3-8.56,7.06-8.55l153.48.37q.11.5.21,1C1532.82,1426.44,1538.54,1442.75,1551.48,1454.82Z",
    transform: "translate(-283.73 -142.21)"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1649.56,
    y: 1432.51,
    width: 41.47,
    height: 3.71,
    transform: "translate(-51.71 2959.09) rotate(-89.87)"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1637,
    y: 1432.48,
    width: 41.47,
    height: 3.71,
    transform: "translate(-64.22 2946.49) rotate(-89.87)"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1621.93,
    y: 1432.44,
    width: 41.47,
    height: 3.71,
    transform: "matrix(0, -1, 1, 0, -79.26, 2931.35)"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1598.83,
    y: 1432.39,
    width: 41.47,
    height: 3.71,
    transform: "matrix(0, -1, 1, 0, -102.25, 2908.2)"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1574.41,
    y: 1432.33,
    width: 41.47,
    height: 3.71,
    transform: "translate(-126.12 2884.11) rotate(-89.88)"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1536.97,
    y: 1432.24,
    width: 41.47,
    height: 3.71,
    transform: "translate(-164.19 2845.84) rotate(-89.85)"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1501.91,
    y: 1432.16,
    width: 41.47,
    height: 3.71,
    transform: "matrix(0, -1, 1, 0, -198.71, 2811.05)"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1470.6,
    y: 1432.08,
    width: 41.47,
    height: 3.71,
    transform: "translate(-229.46 2780.06) rotate(-89.88)"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1661.52,
    y: 1432.54,
    width: 41.47,
    height: 3.71,
    transform: "translate(-39.81 2971.08) rotate(-89.87)"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1669.42,
    y: 1432.56,
    width: 41.47,
    height: 3.71,
    transform: "translate(-31.99 2978.96) rotate(-89.86)"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1677.05,
    y: 1432.58,
    width: 41.47,
    height: 3.71,
    transform: "matrix(0, -1, 1, 0, -24.39, 2986.61)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1701.71,1413.7l-.07,41.48H1704a7.12,7.12,0,0,0,1.39-.14l.07-41.18a6.37,6.37,0,0,0-1.39-.15Z",
    transform: "translate(-283.73 -142.21)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1706.87,1414.32l-.07,40.26a8.25,8.25,0,0,0,3.71-3.37l.06-33.5A8.28,8.28,0,0,0,1706.87,1414.32Z",
    transform: "translate(-283.73 -142.21)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1728.87,1382.34l0,23.42a9.81,9.81,0,0,1-1.36,5,8.19,8.19,0,0,1-3.71,3.37,6.79,6.79,0,0,1-1.45.46,7.23,7.23,0,0,1-1.4.14l-326.6-.77a7.1,7.1,0,0,1-3.64-1,9.13,9.13,0,0,1-4.21-7.14,2.8,2.8,0,0,1,0-.4c0-.16,0-.31,0-.47l0-23.42c0-.15,0-.31,0-.46.23-4.75,3.7-8.56,7.91-8.55l326.61.78a6.37,6.37,0,0,1,1.39.15,6.62,6.62,0,0,1,1.45.46,8.33,8.33,0,0,1,3.7,3.39A10,10,0,0,1,1728.87,1382.34Z",
    transform: "translate(-283.73 -142.21)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1568.43,1414.41l-175-.41a5.84,5.84,0,0,1-3.25-1,9.35,9.35,0,0,1-3.75-7.14,2.8,2.8,0,0,1,0-.4c0-.16,0-.31,0-.47l0-23.42c0-.15,0-.31,0-.46.2-4.75,3.31-8.56,7.07-8.55l153.48.37c2.37,11.88,7.81,28.19,20.34,40.49C1567.71,1413.73,1568.06,1414.07,1568.43,1414.41Z",
    transform: "translate(-283.73 -142.21)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1736.76,1340.89l0,23.42a9.81,9.81,0,0,1-1.36,5,8.2,8.2,0,0,1-3.72,3.36,6.56,6.56,0,0,1-1.44.47,7.23,7.23,0,0,1-1.4.14l-326.6-.78c-4.21,0-7.68-3.83-7.88-8.58,0-.15,0-.31,0-.46l0-23.42c0-.16,0-.31,0-.47.21-4.39,3.2-8,7-8.48a7,7,0,0,1,.93-.06l326.61.77a7,7,0,0,1,1.39.15,6.82,6.82,0,0,1,1.45.47,8.27,8.27,0,0,1,3.7,3.39A9.8,9.8,0,0,1,1736.76,1340.89Z",
    transform: "translate(-283.73 -142.21)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1576.33,1373l-175-.42c-3.76,0-6.85-3.83-7-8.58,0-.15,0-.31,0-.46l0-23.42c0-.16,0-.31,0-.47.18-4.39,2.86-8,6.23-8.48a4.57,4.57,0,0,1,.83-.06l153.49.36a.17.17,0,0,1,0,.07C1557.36,1343.7,1563.05,1360.56,1576.33,1373Z",
    transform: "translate(-283.73 -142.21)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1712.83,1299.42l0,23.42a9.91,9.91,0,0,1-1.37,5,8.31,8.31,0,0,1-3.71,3.37,6.79,6.79,0,0,1-1.45.46l-.46.08-.26,0-.25,0h-.42l-326.61-.77c-4.21,0-7.67-3.83-7.88-8.58,0-.16,0-.31,0-.47l.05-23.42c0-.15,0-.31,0-.46s0-.26,0-.38a8.8,8.8,0,0,1,5.94-7.89l.24-.07a6.91,6.91,0,0,1,1.71-.21l326.6.78c.24,0,.48,0,.71,0l.31,0h0a2.29,2.29,0,0,1,.36.07,6.62,6.62,0,0,1,1.45.46,8.28,8.28,0,0,1,3.7,3.39A9.83,9.83,0,0,1,1712.83,1299.42Z",
    transform: "translate(-283.73 -142.21)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1552.39,1331.49l-175-.42c-3.75,0-6.84-3.82-7-8.57,0-.16,0-.31,0-.47l.05-23.42c0-.15,0-.31,0-.46s0-.26,0-.38c.29-3.91,2.55-7.11,5.49-8l.3-.08a5.7,5.7,0,0,1,1.25-.14L1531,1290a1.59,1.59,0,0,0,.06.3c2.45,12.17,8.13,28.86,21.28,41.16Z",
    transform: "translate(-283.73 -142.21)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1712.22,1258.24l0,23.42a9.81,9.81,0,0,1-1.36,5,8.31,8.31,0,0,1-3.71,3.37,8,8,0,0,1-1.13.39h0l-.31.07a7.12,7.12,0,0,1-1.39.14l-326.61-.77a6.79,6.79,0,0,1-1-.09,2.44,2.44,0,0,1-.39-.07c-3.55-.74-6.29-4.22-6.47-8.43,0-.15,0-.31,0-.46l0-23.42c0-.16,0-.31,0-.46.23-4.76,3.7-8.56,7.91-8.55l326.61.78.63,0,.26,0,.3,0,.2,0a6.62,6.62,0,0,1,1.45.46l.21.1.2.1.39.22.43.28a3.18,3.18,0,0,1,.37.27,4.47,4.47,0,0,1,.41.35,3.84,3.84,0,0,1,.3.28l0,0,.2.2c.2.22.39.45.57.68l.16.21.15.22c.1.15.2.3.29.46A9.83,9.83,0,0,1,1712.22,1258.24Z",
    transform: "translate(-283.73 -142.21)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1551.78,1290.31l-175-.42h-.41a3.25,3.25,0,0,1-.45-.06c-3.37-.54-6-4.12-6.17-8.51,0-.15,0-.31,0-.46l0-23.42c0-.16,0-.31,0-.46.21-4.76,3.31-8.56,7.07-8.55l153.48.36.21,1c2.52,12,8.18,28.16,20.89,40.2Z",
    transform: "translate(-283.73 -142.21)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1729.17,1217.83l-.05,23.42a9.81,9.81,0,0,1-1.36,5,8.28,8.28,0,0,1-3.72,3.37,6.53,6.53,0,0,1-1.44.46,7.23,7.23,0,0,1-1.4.14l-326.6-.78a7,7,0,0,1-3.64-1,9.17,9.17,0,0,1-4.22-7.14c0-.14,0-.27,0-.41s0-.31,0-.46l0-23.42c0-.16,0-.31,0-.47.23-4.75,3.7-8.55,7.91-8.54l326.61.78a7,7,0,0,1,1.39.14,7.23,7.23,0,0,1,1.45.47,8.27,8.27,0,0,1,3.7,3.39A9.93,9.93,0,0,1,1729.17,1217.83Z",
    transform: "translate(-283.73 -142.21)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1568.72,1249.9l-175-.42a5.75,5.75,0,0,1-3.25-1,9.41,9.41,0,0,1-3.76-7.14c0-.14,0-.27,0-.41s0-.31,0-.46l0-23.42c0-.16,0-.31,0-.47.2-4.75,3.31-8.55,7.06-8.54l153.49.36c2.37,11.88,7.81,28.2,20.34,40.5Z",
    transform: "translate(-283.73 -142.21)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1755.93,1176.42l0,23.42a10,10,0,0,1-1.36,5,8.33,8.33,0,0,1-3.72,3.37,6.62,6.62,0,0,1-1.45.46,7,7,0,0,1-1.39.14l-326.61-.78c-4.21,0-7.67-3.83-7.88-8.58V1199l0-23.42c0-.16,0-.31,0-.47.2-4.39,3.19-8,7-8.48a7.3,7.3,0,0,1,.94-.06l326.6.78a7.23,7.23,0,0,1,1.4.14,7.14,7.14,0,0,1,1.44.47,8.24,8.24,0,0,1,3.71,3.39A9.92,9.92,0,0,1,1755.93,1176.42Z",
    transform: "translate(-283.73 -142.21)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1595.49,1208.49l-175-.42c-3.75,0-6.84-3.83-7-8.58V1199l0-23.42c0-.16,0-.31,0-.47.18-4.39,2.85-8,6.23-8.48a5.69,5.69,0,0,1,.83-.06l153.49.36s0,0,0,.07C1576.53,1179.24,1582.21,1196.1,1595.49,1208.49Z",
    transform: "translate(-283.73 -142.21)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1713.13,1134.91l-.05,23.42a9.81,9.81,0,0,1-1.36,5,8.31,8.31,0,0,1-3.71,3.37,6.79,6.79,0,0,1-1.45.46l-.46.08-.37,0h-.56l-326.61-.78c-4.21,0-7.67-3.83-7.88-8.58,0-.15,0-.31,0-.46l0-23.42c0-.16,0-.31,0-.47.23-4.75,3.7-8.55,7.91-8.54l326.61.78h.42a7.55,7.55,0,0,1,1,.13,6.64,6.64,0,0,1,1.45.47,6.19,6.19,0,0,1,.68.35c.14.08.28.16.41.25l0,0c.14.09.27.19.4.29a.18.18,0,0,1,.07,0l.35.29a6.47,6.47,0,0,1,.78.79,2.85,2.85,0,0,1,.23.26l0,0,.13.17,0,0c.08.1.15.21.23.33s.21.32.31.49A9.8,9.8,0,0,1,1713.13,1134.91Z",
    transform: "translate(-283.73 -142.21)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1552.69,1167l-175-.42c-3.75,0-6.85-3.83-7-8.58,0-.15,0-.31,0-.46l0-23.42c0-.16,0-.31,0-.47.21-4.75,3.31-8.55,7.07-8.54l153.48.36c.07.32.13.64.2,1,2.53,12.11,8.24,28.42,21.15,40.5Z",
    transform: "translate(-283.73 -142.21)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1737.21,1094.45l0,23.42a9.81,9.81,0,0,1-1.36,5,8.28,8.28,0,0,1-3.72,3.37,6.71,6.71,0,0,1-1.44.46,7.23,7.23,0,0,1-1.4.14l-326.6-.77a7.16,7.16,0,0,1-3.53-1,9.14,9.14,0,0,1-4.33-7.25c0-.12,0-.24,0-.37s0-.3,0-.46l0-23.42c0-.16,0-.31,0-.46.21-4.4,3.2-8,7-8.48a5.65,5.65,0,0,1,.93-.07l326.61.78a7.12,7.12,0,0,1,1.39.14,7.44,7.44,0,0,1,1.45.47,8.33,8.33,0,0,1,3.7,3.39A9.82,9.82,0,0,1,1737.21,1094.45Z",
    transform: "translate(-283.73 -142.21)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1576.77,1126.52l-175-.42a5.8,5.8,0,0,1-3.15-1,9.35,9.35,0,0,1-3.86-7.25c0-.12,0-.24,0-.37s0-.3,0-.46l0-23.42c0-.16,0-.31,0-.46.18-4.39,2.85-8,6.23-8.49a5.69,5.69,0,0,1,.83-.06l153.49.36a.17.17,0,0,1,0,.07c2.38,11.9,7.84,28.21,20.4,40.5Z",
    transform: "translate(-283.73 -142.21)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1713.28,1053l0,23.42a9.8,9.8,0,0,1-1.36,5,8.19,8.19,0,0,1-3.71,3.37,6.27,6.27,0,0,1-1.45.46l-.46.08-.26,0-.26,0-.42,0-326.6-.78c-4.21,0-7.67-3.83-7.88-8.58,0-.16,0-.31,0-.47l0-23.42c0-.15,0-.31,0-.46.23-4.75,3.7-8.55,7.91-8.54l326.61.77a6.37,6.37,0,0,1,1.39.15,6.64,6.64,0,0,1,1.45.47,8.25,8.25,0,0,1,3.7,3.38A9.87,9.87,0,0,1,1713.28,1053Z",
    transform: "translate(-283.73 -142.21)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1552.84,1085.05l-175-.41c-3.76,0-6.85-3.83-7-8.58,0-.16,0-.31,0-.47l0-23.42c0-.15,0-.31,0-.46.21-4.75,3.31-8.55,7.07-8.55l153.48.37c2.43,12.19,8.09,29,21.35,41.46Z",
    transform: "translate(-283.73 -142.21)"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1666.51,
    y: 1392.1,
    width: 41.47,
    height: 3.71,
    transform: "translate(5.56 2935.68) rotate(-89.86)"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1653.95,
    y: 1392.07,
    width: 41.47,
    height: 3.71,
    transform: "translate(-6.49 2923.47) rotate(-89.88)"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1638.88,
    y: 1392.03,
    width: 41.47,
    height: 3.71,
    transform: "translate(-21.54 2908.32) rotate(-89.88)"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1615.78,
    y: 1391.98,
    width: 41.47,
    height: 3.71,
    transform: "translate(-44.93 2884.83) rotate(-89.86)"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1591.36,
    y: 1391.92,
    width: 41.47,
    height: 3.71,
    transform: "translate(-69.23 2860.35) rotate(-89.86)"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1553.91,
    y: 1391.83,
    width: 41.47,
    height: 3.71,
    transform: "translate(-106.5 2822.82) rotate(-89.86)"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1518.86,
    y: 1391.75,
    width: 41.47,
    height: 3.71,
    transform: "translate(-140.98 2788.06) rotate(-89.88)"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1487.55,
    y: 1391.68,
    width: 41.47,
    height: 3.71,
    transform: "translate(-172.54 2756.3) rotate(-89.86)"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1678.47,
    y: 1392.13,
    width: 41.47,
    height: 3.71,
    transform: "matrix(0, -1, 1, 0, 17.47, 2947.67)"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1686.37,
    y: 1392.15,
    width: 41.47,
    height: 3.71,
    transform: "translate(25.79 2955.97) rotate(-89.88)"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1694,
    y: 1392.16,
    width: 41.47,
    height: 3.71,
    transform: "matrix(0, -1, 1, 0, 32.93, 2963.24)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1718.66,1373.29l-.07,41.48h2.32a7.2,7.2,0,0,0,1.39-.14l.07-41.18a6.37,6.37,0,0,0-1.39-.15Z",
    transform: "translate(-283.73 -142.21)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1723.82,1373.91l-.07,40.26a8.31,8.31,0,0,0,3.71-3.37l.06-33.5A8.27,8.27,0,0,0,1723.82,1373.91Z",
    transform: "translate(-283.73 -142.21)"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1561.81,
    y: 1350.38,
    width: 41.47,
    height: 3.71,
    transform: "matrix(0, -1, 1, 0, -57.16, 2789.36)"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1526.76,
    y: 1350.29,
    width: 41.47,
    height: 3.71,
    transform: "translate(-92.01 2754.26) rotate(-89.87)"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1495.45,
    y: 1350.22,
    width: 41.47,
    height: 3.71,
    transform: "translate(-123.21 2722.85) rotate(-89.86)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1708.92,1373.27l.08-41.47h-3.26l.52-.08.08-41.19c-.23,0-.46-.08-.69-.1l.07-40.19h1.45l-.07,39.84a8.31,8.31,0,0,0,3.71-3.37l.06-33.5a8.45,8.45,0,0,0-2.94-3h1.3l.07-41.47h-3.71l-.07,40.56a6.67,6.67,0,0,0-1.19-.11H1702l-.07,41.48h.68l-.07,41.17h2.32l.42,0-.08,41.43Z",
    transform: "translate(-283.73 -142.21)"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1694.27,
    y: 1350.69,
    width: 41.47,
    height: 3.71,
    transform: "translate(74.67 2922.14) rotate(-89.86)"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1701.9,
    y: 1350.71,
    width: 41.47,
    height: 3.71,
    transform: "matrix(0, -1, 1, 0, 81.84, 2929.45)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1726.56,1331.84l-.08,41.47h2.32a6.53,6.53,0,0,0,1.4-.15l.07-41.18a6.37,6.37,0,0,0-1.39-.15Z",
    transform: "translate(-283.73 -142.21)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1731.72,1332.46l-.08,40.25a8.17,8.17,0,0,0,3.72-3.37l.06-33.5A8.31,8.31,0,0,0,1731.72,1332.46Z",
    transform: "translate(-283.73 -142.21)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1389.3 1189.57 1389.37 1148.09 1388.68 1148.09 1388.76 1106.91 1385.05 1106.91 1384.97 1148.38 1385.66 1148.38 1385.58 1189.49 1381.96 1189.48 1381.89 1230.96 1385.6 1230.97 1385.67 1189.56 1389.3 1189.57"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1361.74 1148.03 1361.05 1148.03 1361.13 1106.85 1357.41 1106.84 1357.34 1148.31 1358.03 1148.32 1357.95 1189.49 1358.87 1189.49 1358.79 1230.9 1362.5 1230.91 1362.58 1189.44 1361.66 1189.44 1361.74 1148.03"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1707.78,1291l-.07,40.26a8.31,8.31,0,0,0,3.71-3.37l.06-33.5A8.22,8.22,0,0,0,1707.78,1291Z",
    transform: "translate(-283.73 -142.21)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1338.03 1106.79 1334.32 1106.79 1334.24 1148.26 1334.93 1148.26 1334.85 1189.37 1334.44 1189.37 1334.37 1230.84 1338.08 1230.85 1338.15 1189.44 1338.57 1189.45 1338.64 1147.97 1337.95 1147.97 1338.03 1106.79"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1313.61 1106.74 1309.89 1106.73 1309.82 1148.2 1310.51 1148.2 1310.43 1189.38 1314.14 1189.39 1314.22 1147.91 1313.53 1147.91 1313.61 1106.74"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1276.16 1106.65 1272.45 1106.64 1272.38 1148.11 1273.06 1148.11 1272.99 1189.29 1276.7 1189.3 1276.78 1147.83 1276.09 1147.82 1276.16 1106.65"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1241.11 1106.56 1237.39 1106.56 1237.32 1148.03 1238.01 1148.03 1237.93 1189.21 1241.64 1189.22 1241.72 1147.74 1241.03 1147.74 1241.11 1106.56"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1209.8 1106.49 1206.09 1106.48 1206.01 1147.95 1206.7 1147.95 1206.63 1189.13 1210.34 1189.14 1210.41 1147.67 1209.73 1147.67 1209.8 1106.49"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1400.72 1106.94 1397.01 1106.93 1396.93 1148.41 1397.62 1148.41 1397.54 1189.52 1397.03 1189.52 1396.95 1230.99 1400.67 1231 1400.74 1189.59 1401.26 1189.6 1401.33 1148.12 1400.64 1148.12 1400.72 1106.94"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1408.62 1106.96 1405.63 1106.95 1405.71 1066.5 1402 1066.49 1401.92 1107.97 1404.91 1107.98 1404.83 1148.43 1405.52 1148.43 1405.45 1189.61 1409.16 1189.61 1409.23 1148.14 1408.55 1148.14 1408.62 1106.96"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1654.24,
    y: 1227.56,
    width: 41.47,
    height: 3.71,
    transform: "translate(157.87 2759.27) rotate(-89.86)"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1374.29 1106.88 1372.48 1106.88 1372.41 1148.35 1373.09 1148.35 1373.02 1189.53 1376.73 1189.54 1376.81 1148.06 1376.12 1148.06 1376.19 1107.91 1378 1107.91 1378.08 1066.44 1374.36 1066.43 1374.29 1106.88"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1616.08,
    y: 1227.47,
    width: 41.47,
    height: 3.71,
    transform: "translate(119.44 2720.68) rotate(-89.85)"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1591.66,
    y: 1227.41,
    width: 41.47,
    height: 3.71,
    transform: "translate(95.58 2696.53) rotate(-89.86)"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1554.21,
    y: 1227.32,
    width: 41.47,
    height: 3.71,
    transform: "translate(58.35 2659.03) rotate(-89.87)"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1519.16,
    y: 1227.24,
    width: 41.47,
    height: 3.71,
    transform: "translate(23.79 2624.16) rotate(-89.88)"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1487.85,
    y: 1227.16,
    width: 41.47,
    height: 3.71,
    transform: "translate(-7.73 2592.48) rotate(-89.86)"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1413.88 1106.97 1412.54 1106.97 1412.46 1148.44 1413.15 1148.45 1413.08 1189.56 1409.6 1189.55 1409.52 1231.02 1413.23 1231.03 1413.31 1189.62 1416.79 1189.63 1416.86 1148.16 1416.18 1148.16 1416.25 1108 1417.59 1108.01 1417.67 1066.53 1413.96 1066.52 1413.88 1106.97"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1694.3,
    y: 1227.65,
    width: 41.47,
    height: 3.71,
    transform: "matrix(0, -1, 1, 0, 197.73, 2799.42)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1722.6,1250.12l.07-41.18a6.37,6.37,0,0,0-1.39-.15H1719l-.08,41.47h2.33A7.2,7.2,0,0,0,1722.6,1250.12Z",
    transform: "translate(-283.73 -142.21)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1727.76,1246.29l.06-33.5a8.33,8.33,0,0,0-3.7-3.39l-.08,40.26A8.28,8.28,0,0,0,1727.76,1246.29Z",
    transform: "translate(-283.73 -142.21)"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1693.58,
    y: 1186.18,
    width: 41.47,
    height: 3.71,
    transform: "translate(238.49 2757.32) rotate(-89.86)"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1642.85,
    y: 1186.06,
    width: 41.47,
    height: 3.71,
    transform: "matrix(0, -1, 1, 0, 188, 2706.47)"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1618.42,
    y: 1186,
    width: 41.47,
    height: 3.71,
    transform: "translate(163.69 2681.99) rotate(-89.86)"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1580.98,
    y: 1185.91,
    width: 41.47,
    height: 3.71,
    transform: "translate(126.42 2644.45) rotate(-89.86)"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1545.92,
    y: 1185.83,
    width: 41.47,
    height: 3.71,
    transform: "translate(91.53 2609.32) rotate(-89.86)"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1514.62,
    y: 1185.75,
    width: 41.47,
    height: 3.71,
    transform: "translate(60.79 2578.26) rotate(-89.88)"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1705.54,
    y: 1186.21,
    width: 41.47,
    height: 3.71,
    transform: "translate(250.39 2769.31) rotate(-89.86)"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1713.44,
    y: 1186.23,
    width: 41.47,
    height: 3.71,
    transform: "matrix(0, -1, 1, 0, 258.25, 2777.23)"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1721.07,
    y: 1186.24,
    width: 41.47,
    height: 3.71,
    transform: "translate(265.89 2784.91) rotate(-89.87)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1745.73,1167.37l-.08,41.47H1748a7.23,7.23,0,0,0,1.4-.14l.07-41.19a7.12,7.12,0,0,0-1.39-.14Z",
    transform: "translate(-283.73 -142.21)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1750.88,1168l-.07,40.26a8.28,8.28,0,0,0,3.72-3.37l.06-33.5A8.24,8.24,0,0,0,1750.88,1168Z",
    transform: "translate(-283.73 -142.21)"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1385.88 1025.05 1389.59 1025.06 1389.67 983.58 1386.05 983.57 1386.12 943.12 1389.74 943.13 1389.82 901.66 1386.11 901.65 1386.03 943.06 1382.41 943.05 1382.34 984.52 1385.96 984.53 1385.88 1025.05"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1638.21,
    y: 1144.64,
    width: 41.47,
    height: 3.71,
    transform: "translate(224.34 2660.19) rotate(-89.85)"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1575.62,
    y: 1144.49,
    width: 41.47,
    height: 3.71,
    transform: "translate(162.5 2597.77) rotate(-89.86)"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1538.18,
    y: 1144.4,
    width: 41.47,
    height: 3.71,
    transform: "translate(125.27 2560.27) rotate(-89.87)"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1503.12,
    y: 1144.32,
    width: 41.47,
    height: 3.71,
    transform: "matrix(0, -1, 1, 0, 90.34, 2525.1)"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1471.81,
    y: 1144.24,
    width: 41.47,
    height: 3.71,
    transform: "translate(59.23 2493.75) rotate(-89.87)"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1397.84 1025.08 1401.13 1025.08 1401.05 1066.49 1404.77 1066.5 1404.84 1025.03 1401.56 1025.02 1401.63 983.61 1401.12 983.61 1401.19 943.16 1401.7 943.16 1401.78 901.69 1398.07 901.68 1397.99 943.09 1397.48 943.08 1397.4 984.56 1397.92 984.56 1397.84 1025.08"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1670.63,
    y: 1144.72,
    width: 41.47,
    height: 3.71,
    transform: "translate(257.97 2693.63) rotate(-89.89)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1708.72,1126.83h.65l.08-41.47h-3.26a4.34,4.34,0,0,0,.52-.08l.07-41.18a6.37,6.37,0,0,0-1.39-.15h-2.32l-.07,41.47h2.31a3,3,0,0,0,.43,0l-.08,40.5-.42,0h-2.32l-.07,41.41h-2l.07-41.41h-3.48l.08-40.45H1701l.07-41.48h-3.71l-.07,41.41h-3.48l-.08,41.48h3.48l-.07,40.52h2.82l-.08,41.41h3.72l.07-41.41h1.53a7.12,7.12,0,0,0,1.39-.14l.07-40.37h1.45l-.07,39.91a8.31,8.31,0,0,0,3.71-3.37l.06-33.5A8.33,8.33,0,0,0,1708.72,1126.83Z",
    transform: "translate(-283.73 -142.21)"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1562.26,
    y: 1103.94,
    width: 41.47,
    height: 3.71,
    transform: "translate(190.14 2544.26) rotate(-89.88)"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1527.2,
    y: 1103.86,
    width: 41.47,
    height: 3.71,
    transform: "matrix(0, -1, 1, 0, 154.83, 2508.82)"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1495.9,
    y: 1103.78,
    width: 41.47,
    height: 3.71,
    transform: "translate(123.67 2477.44) rotate(-89.86)"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1694.72,
    y: 1104.26,
    width: 41.47,
    height: 3.71,
    transform: "translate(321.6 2676.76) rotate(-89.87)"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1702.35,
    y: 1104.27,
    width: 41.47,
    height: 3.71,
    transform: "matrix(0, -1, 1, 0, 329.14, 2684.38)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1727,1085.4l-.08,41.48h2.32a7.23,7.23,0,0,0,1.4-.14l.07-41.19a7.12,7.12,0,0,0-1.39-.14Z",
    transform: "translate(-283.73 -142.21)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1735.81,1122.91l.06-33.5a8.27,8.27,0,0,0-3.7-3.39l-.08,40.26A8.28,8.28,0,0,0,1735.81,1122.91Z",
    transform: "translate(-283.73 -142.21)"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1638.35,
    y: 1062.71,
    width: 41.47,
    height: 3.71,
    transform: "translate(306.86 2578.92) rotate(-89.86)"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1362.19 901.59 1358.47 901.58 1358.4 943.06 1359.31 943.06 1359.24 983.51 1358.33 983.51 1358.25 1024.98 1361.96 1024.99 1362.04 984.47 1362.95 984.48 1363.03 943 1362.11 943 1362.19 901.59"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1335.3 942.94 1334.89 942.94 1334.82 984.41 1335.23 984.41 1335.15 1024.93 1338.87 1024.94 1338.94 983.46 1338.53 983.46 1338.6 943.01 1339.01 943.01 1339.09 901.54 1335.38 901.53 1335.3 942.94"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1575.77,
    y: 1062.56,
    width: 41.47,
    height: 3.71,
    transform: "matrix(0, -1, 1, 0, 244.57, 2516.19)"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1538.33,
    y: 1062.48,
    width: 41.47,
    height: 3.71,
    transform: "matrix(0, -1, 1, 0, 207.31, 2478.66)"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1503.27,
    y: 1062.39,
    width: 41.47,
    height: 3.71,
    transform: "translate(172.05 2443.26) rotate(-89.85)"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1471.96,
    y: 1062.32,
    width: 41.47,
    height: 3.71,
    transform: "translate(141.66 2412.43) rotate(-89.88)"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1670.78,
    y: 1062.79,
    width: 41.47,
    height: 3.71,
    transform: "translate(338.68 2611.14) rotate(-89.85)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1708.23,1044.56l-.07,40.25a8.19,8.19,0,0,0,3.71-3.37l.06-33.5A8.2,8.2,0,0,0,1708.23,1044.56Z",
    transform: "translate(-283.73 -142.21)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1817.05,1155.13l23.06,4.09a9.78,9.78,0,0,1,4.72,2.22,8.19,8.19,0,0,1,2.68,4.24,6.37,6.37,0,0,1,.2,1.5,6,6,0,0,1-.1,1.4l-57.29,321.55c-.74,4.14-5.1,6.89-9.81,6.27l-.46-.07-23.06-4.1-.46-.09c-4.64-1-7.78-5.12-7-9.27l57.29-321.54a4.15,4.15,0,0,1,.14-.61,2.5,2.5,0,0,1,.07-.26c0-.09.06-.19.1-.28s.05-.13.07-.2a6.92,6.92,0,0,1,.72-1.34l.12-.19.14-.18.28-.35.19-.2a1.29,1.29,0,0,1,.16-.17l.33-.32.41-.34.34-.25h0l.24-.17a7.15,7.15,0,0,1,.76-.44l.24-.12.24-.11a4.4,4.4,0,0,1,.5-.21A9.83,9.83,0,0,1,1817.05,1155.13Z",
    transform: "translate(-283.73 -142.21)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1820.87,1318.7,1790.17,1491c-.66,3.7-5,6.08-9.66,5.44l-.46-.07-23.06-4.1-.46-.09c-4.64-1-7.85-4.73-7.19-8.43l26.92-151.11,1,0C1789.68,1332.17,1806.74,1329.35,1820.87,1318.7Z",
    transform: "translate(-283.73 -142.21)"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1819.43,
    y: 1177.39,
    width: 3.71,
    height: 41.47,
    transform: "translate(38.02 2638.32) rotate(-79.88)"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1817.22,
    y: 1189.76,
    width: 3.71,
    height: 41.47,
    transform: "translate(24.82 2647.11) rotate(-79.91)"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1814.58,
    y: 1204.6,
    width: 3.71,
    height: 41.47,
    transform: "translate(7.7 2656.41) rotate(-79.9)"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1810.53,
    y: 1227.34,
    width: 3.71,
    height: 41.47,
    transform: "translate(-18.03 2671.17) rotate(-79.9)"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1806.25,
    y: 1251.38,
    width: 3.71,
    height: 41.47,
    transform: "translate(-44.9 2687.12) rotate(-79.91)"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1799.68,
    y: 1288.24,
    width: 3.71,
    height: 41.47,
    transform: "translate(-86.97 2710.68) rotate(-79.89)"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1793.53,
    y: 1322.76,
    width: 3.71,
    height: 41.47,
    transform: "translate(-125.66 2733.47) rotate(-79.91)"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1788.04,
    y: 1353.58,
    width: 3.71,
    height: 41.47,
    transform: "translate(-161.23 2752.72) rotate(-79.88)"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1821.53,
    y: 1165.62,
    width: 3.71,
    height: 41.47,
    transform: "translate(51.8 2631.11) rotate(-79.9)"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1822.91,
    y: 1157.84,
    width: 3.71,
    height: 41.47,
    transform: "translate(60.57 2626.03) rotate(-79.89)"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1824.25,
    y: 1150.33,
    width: 3.71,
    height: 41.47,
    transform: "translate(69.1 2621.18) rotate(-79.9)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1806.37,1163.61l40.83,7.26.41-2.29a6.6,6.6,0,0,0,.1-1.4l-40.55-7.2a6.74,6.74,0,0,0-.38,1.35Z",
    transform: "translate(-283.73 -142.21)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1807.87,1158.64l39.64,7a8.19,8.19,0,0,0-2.68-4.24l-33-5.86A8.26,8.26,0,0,0,1807.87,1158.64Z",
    transform: "translate(-283.73 -142.21)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2595.46,1496.36H2455.11c-7.52-6.38,5.21-20.87,18.5-21.85,5.78-.43,13.08.78,21.43,2.54,1.93-25.65,13-141,54.52-136.34,46.74,5.19,0,50.78-13.21,77.78-9.79,20-20.11,48.67-24.83,62.2,3.8.82,7.73,1.63,11.74,2.37,6.19-19,29.24-83,58.56-79.28,34.41,4.37,20.58,30-3.82,45.25-17.89,11.2-39.87,27.11-50.31,34.8a148.46,148.46,0,0,0,27.45,2.2C2579.18,1485.46,2590.92,1492.54,2595.46,1496.36Z",
    transform: "translate(-283.73 -142.21)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M765.43,1491.7c-5.57-8.76-22.35-31.49-44.69-28.48-24.35,3.28,26.88,19.33,42.57,28.54a26.06,26.06,0,0,1-8.68-1c-10.49-3.74-28.44,3.43-34.19,5.94h99.83a15.84,15.84,0,0,0-7.14-9.13c-1.63-1-4.93-1.14-9.18-.81,5.93-7,10-29.35-6.47-23.6-12.07,4.2-12,17.86-10.85,25.94-2.57.4-5.18.81-7.75,1.18-5-25.33-22.55-99.57-58.18-101.55-36.12-2,30.63,77,52.86,102.26C770.71,1491.32,768,1491.58,765.43,1491.7Z",
    transform: "translate(-283.73 -142.21)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 1653.66,
    cy: 759.51,
    r: 143.76,
    transform: "translate(-336.44 1249.56) rotate(-45)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1642.68,
    cy: 765.56,
    r: 143.76,
    transform: "translate(201.22 2017.68) rotate(-75.28)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1643.72,898a131,131,0,1,1,114.49-194.19c34.86,63.25,11.77,143.07-51.48,177.94A130.19,130.19,0,0,1,1643.72,898Zm-.4-254.18a123.54,123.54,0,1,0,34.41,4.91A122.49,122.49,0,0,0,1643.32,643.83Z",
    transform: "translate(-283.73 -142.21)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1677.64,791.64a21.41,21.41,0,0,0-3.94-6.51,15.67,15.67,0,0,0-5.86-4,29.87,29.87,0,0,0-8.38-1.87,79.09,79.09,0,0,0-11.42-.07q-11.34.54-21,0a65.44,65.44,0,0,1-17.46-3.17,38.39,38.39,0,0,1-13.71-8,43.3,43.3,0,0,1-12.74-30.35,36.41,36.41,0,0,1,3.45-14.78,45.31,45.31,0,0,1,9.38-13.07,60.76,60.76,0,0,1,14.88-10.6l-8.17-20.14,16.21-6.58,8.29,20.42a54.47,54.47,0,0,1,17.68-1.8,41.1,41.1,0,0,1,28.71,14.16,54.86,54.86,0,0,1,9.59,15.9l-29.29,11.89q-4.59-11.3-11.87-14.86t-15.71-.15a23.56,23.56,0,0,0-7.33,4.46,16,16,0,0,0-4,5.69,14.82,14.82,0,0,0-1,6.5,21.89,21.89,0,0,0,1.62,6.9,20.15,20.15,0,0,0,3.58,5.9,14.78,14.78,0,0,0,5.62,3.8,29.44,29.44,0,0,0,8.42,1.84,99.1,99.1,0,0,0,12,.25q11.31-.31,20.94.27a65.91,65.91,0,0,1,17.44,3.27,37,37,0,0,1,23.34,22.6,39.48,39.48,0,0,1,3.15,16,36,36,0,0,1-3.53,14.71,44,44,0,0,1-9.58,12.88,65.48,65.48,0,0,1-15,10.49l7.6,18.73L1673.34,859l-7.57-18.63a73.27,73.27,0,0,1-17.75,2.93,46.6,46.6,0,0,1-17.24-2.49,41.46,41.46,0,0,1-15.17-9.46q-6.93-6.62-11.52-17.91l29.28-11.89a31,31,0,0,0,6.41,10.39,20,20,0,0,0,7.92,5.12,19.59,19.59,0,0,0,8.67.87,34.08,34.08,0,0,0,8.59-2.23,28,28,0,0,0,7.87-4.62,18.76,18.76,0,0,0,4.65-5.84,14.7,14.7,0,0,0,1.56-6.61A18,18,0,0,0,1677.64,791.64Z",
    transform: "translate(-283.73 -142.21)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1785.74,682.14c-6-4.25-19.66-13.59-20.36-11.51-.51,1.5.21,4,1.85,6.69-8.25-3.08-16.63-5.1-36.44-1.3a14.88,14.88,0,0,0-9.74,6.42c-2,3.14-2.77,7.07,2.28,10.22,10.11,6.28,7.18,2.52,21.23,11.67s31.24,11.49,41.52,5.06l13.79-2.3,1.71-22.68S1793.72,683.47,1785.74,682.14Z",
    transform: "translate(-283.73 -142.21)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2147.11,491.89s-32.51,38.57-73.91,22.43c0,0-8.91-21.54-9-37.42,0-1.95,0-3.85-.07-5.65-.22-17.88-.83-27.91-.83-27.91h0c1.89-.79,63.3-26,63.24-23.9C2125.5,467.79,2147.11,491.89,2147.11,491.89Z",
    transform: "translate(-283.73 -142.21)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2120.39,431c-5.92,11-26.24,32.45-56.29,40.29-.22-17.88-.83-27.91-.83-27.91h0C2065,442.87,2122.15,427.72,2120.39,431Z",
    transform: "translate(-283.73 -142.21)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2050.41,441.48s69.06,16.23,78.51-26.93,24.72-70.13-19-82.32-55.89,2.4-62.55,16S2032.69,436.14,2050.41,441.48Z",
    transform: "translate(-283.73 -142.21)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2126.56,426.31c.94.61,15.8,5.17,43.94-50.89,4.42-8.8,7.43-27.84-2.87-44.66s-46.81-30-77.15-35.8-37.61,11.31-44.76,28.47c-7.5,18-29.16,32.83-29.16,32.83,26.16,14.62,57.67-6.28,68.59-2.85s14.77,20.64,15.59,26.16,2.07,10.09,15.8,5.17,6.21,19.45,4,24.11C2120.55,408.85,2118.68,421.27,2126.56,426.31Z",
    transform: "translate(-283.73 -142.21)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2304.46,1502.67h41.81c8.77,0,18.51-8.77,20.94-24.84s20.46-24.85,24.36-38-16.08-31.67-16.08-31.67l-3.34-4.3-3.47-4.47-33.13,7.79s-.81,7.89-1.32,17.93a229,229,0,0,0-.14,23c1,17.54-4.91,36.43-20.49,39.84S2304.46,1502.67,2304.46,1502.67Z",
    transform: "translate(-283.73 -142.21)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2013.35,1502.67h110.84a9.55,9.55,0,0,0,2.36-.68c7.4-3.7,5.08-32,4.19-40.79-.17-1.62-.29-2.57-.29-2.57s-39-31.18-44.34-7.31c-.17.75-.37,1.48-.57,2.2h0c-6.77,22.34-37,32.48-54.49,35.31C2017.7,1491,2014.24,1498.79,2013.35,1502.67Z",
    transform: "translate(-283.73 -142.21)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M2035.69,863.48s5.92,73.85,12.88,162.63c9.45,120.59,20.82,268.72,21.95,296.78,1.94,48.73,9.75,126.68,9.75,126.68s18.5,18.51,55.54,10.71c0,0,33-111.27,42.43-229q.21-2.9.44-5.82c8.77-119.84,22.4-372.21,22.4-372.21Z",
    transform: "translate(-283.73 -142.21)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2035.69,863.48s5.92,73.85,12.88,162.63l129.67,205.17q.21-2.9.44-5.82c8.77-119.84,22.4-372.21,22.4-372.21Z",
    transform: "translate(-283.73 -142.21)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M2062.72,872.25s106.7,267.46,176.85,393.16,92.08,160.77,92.08,160.77,40.19-16.08,43.85-27c0,0-26.83-242.66-73.81-301.81-26.55-33.43-57.73-133.73-59.19-168.81S2233,824,2233,824Z",
    transform: "translate(-283.73 -142.21)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2306,823.65l1.13,17.2s-11.34,30.56,20.44,46.24c0,0,13.61,5.49,14.16-5.11s-1.19-6.6-.08-21.52-4.76-29-14.63-33.76l-8.09-9.34Z",
    transform: "translate(-283.73 -142.21)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M2318.46,836.18c-11.81,3.79-13.7,2.93-13.7,2.93s-57.48-104.65-63.3-114.23-122-117.35-122-117.35l29.86-111.37s132.18,171.17,146.46,195.73c23.59,40.59,37.41,134.85,37.41,134.85A34.6,34.6,0,0,1,2318.46,836.18Z",
    transform: "translate(-283.73 -142.21)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2013.17,651.26c.41,22.87,1.74,48.58,3.53,74.69l.33,4.65c1.15,16.18,2.39,32.39,3.82,48.2.57,6.34,1.18,12.61,1.81,18.77l.1.82c0,2.31.33,4.81.59,7.09,5.82,59.22,11.93,106,13.07,106.73a6.55,6.55,0,0,0,4.54,1.16c15.54-2,61.87,1.57,99.81-6.68,32-6.75,59.58-19.56,88.79-36.82,3.88-2.29,12.72-8.36,12-12.9-.71-5-2-12.19-3.67-21.25-5.76-31.5-15.69-85.69-19.08-149.11q-1-17.72-2.86-35c-3.26-29.88-8.48-58.26-15.48-83.47-13-46.84-32.12-82.71-56.1-96.74-3.13-1.76-20,9-35.48,18.91-14.3,9.16-29.35,11.7-44,10.42L2052,515c-15.61,18.14-32.22,42.29-36.76,76.62-.34,2.54-.63,5.23-.88,8.1C2013.12,613.73,2012.81,631.43,2013.17,651.26Z",
    transform: "translate(-283.73 -142.21)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M2013.17,651.26c.41,22.87,1.74,48.58,3.53,74.69l.33,4.65c88.72-55.53,102.39-157.15,102.39-157.15-43.65,1.92-78.32,11.95-105.05,26.3C2013.12,613.73,2012.81,631.43,2013.17,651.26Z",
    transform: "translate(-283.73 -142.21)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1789,695c-.91-13.16,5.9-15.35,5.9-15.35s133.76-24.24,145.13-27.82,108.61-104.72,108.61-104.72,37.27-42,67.78-32.75c26.52,8.07,36.89,28.75,40.41,48.46a58,58,0,0,1-27,59.58c-45.65,28-137,83.17-158.56,89.48-47.9,14-176.6,1.12-176.6,1.12A41.54,41.54,0,0,1,1789,695Z",
    transform: "translate(-283.73 -142.21)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1946.4,951.92v497.2a52.9,52.9,0,0,1-52.73,52.74H1382.6a53.22,53.22,0,0,1-12.89-1.58,54.33,54.33,0,0,1-35-27.56c-.16-.3-.31-.6-.47-.92a53.06,53.06,0,0,1-5.46-20.14c-.1-1.22-.14-2.46-.14-3.71V955.11a81.6,81.6,0,0,1,37.92-68.69l.06,0A70.69,70.69,0,0,0,1396,805.67h483.14A70.64,70.64,0,0,0,1906,884.78h0c1.22.84,2.47,1.66,3.73,2.42h0A75.82,75.82,0,0,1,1946.4,951.92Z",
    transform: "translate(-283.73 -142.21)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1946.4,951.92v497.2a52.91,52.91,0,0,1-49,52.6c-1.22.09-2.47.14-3.72.14h-225a54.07,54.07,0,0,1-53.9-53.91V955.11a81.58,81.58,0,0,1,37.92-68.69A70.63,70.63,0,0,0,1682,805.67h197.1a70.65,70.65,0,0,0,30.66,81.55A75.82,75.82,0,0,1,1946.4,951.92Z",
    transform: "translate(-283.73 -142.21)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1906,884.78c-15.78-9.45-84.15-42.95-258-41.53-199.13,1.63-278.9,41.88-281.35,43.13A70.69,70.69,0,0,0,1396,805.67h483.14A70.64,70.64,0,0,0,1906,884.78Z",
    transform: "translate(-283.73 -142.21)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1890.06,802.19v22.55a4,4,0,0,1-4,4h-497a4,4,0,0,1-4-4V802.19a4.05,4.05,0,0,1,4-4h497A4,4,0,0,1,1890.06,802.19Z",
    transform: "translate(-283.73 -142.21)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1890.06,802.19v22.55a4,4,0,0,1-4,4H1697.92a4.05,4.05,0,0,1-4-4V802.19a4.06,4.06,0,0,1,4-4H1886A4,4,0,0,1,1890.06,802.19Z",
    transform: "translate(-283.73 -142.21)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1558.5,913.85s-12.81,18-24.55,18.28-29.61-8.35-29.61-8.35-10.78-24-3.47-33.44a15.72,15.72,0,0,1,15,2.47,22.5,22.5,0,0,1,4,3.8,12.57,12.57,0,0,0,6.17,4.18c8.38,2.55,18.32-3.45,22,2.34a39.27,39.27,0,0,0,6.48,7.67A29.4,29.4,0,0,0,1558.5,913.85Z",
    transform: "translate(-283.73 -142.21)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1391.51,1043.92s45.28-109.7,126.77-111.79c0,0,75.22,8.36,79.4,111.79Z",
    transform: "translate(-283.73 -142.21)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1496,935.48s32.67,7.27,42.74,3c0,0,1.53-13.66-12.23-11.74-9.41,1.31-15.55-3.22-19.15-5C1502.2,919.09,1494.59,929.77,1496,935.48Z",
    transform: "translate(-283.73 -142.21)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1524.38,914.9c-2.09,1.56-8.51-22.09-8.51-22.09a22.5,22.5,0,0,1,4,3.8,12.57,12.57,0,0,0,6.17,4.18C1526,901.48,1526.4,913.37,1524.38,914.9Z",
    transform: "translate(-283.73 -142.21)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1554.53,910.8c-.46.27-15.57,9.32-17.62,9.32s11.14-17,11.14-17A39.27,39.27,0,0,0,1554.53,910.8Z",
    transform: "translate(-283.73 -142.21)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1435.74,1013.28c-.84-.72,32-48.41,41.09-48.76s29.4,10.45,44.13,11.84,29-2.78,31.79,5.92,10.45,39.58,5.75,44.51S1453.82,1028.72,1435.74,1013.28Z",
    transform: "translate(-283.73 -142.21)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1399.13,1464.29c-2.62,1.38-5.25,2.68-7.91,3.94-2.53,1.46-5.1,2.89-7.72,4.26a210.36,210.36,0,0,1-37.19,15.23,54.41,54.41,0,0,1-11.55-15c-2,1.07-4,2.11-6.07,3.12V1100.7a213.79,213.79,0,0,1,27.56,5.55c50.68,13.69,95.81,45.94,123.26,93.37C1534,1293.84,1498.05,1412.34,1399.13,1464.29Z",
    transform: "translate(-283.73 -142.21)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1433.4,1184.84c-54.52-98.92-178.92-134.9-277.84-80.38s-134.9,178.93-80.37,277.84,178.92,134.91,277.84,80.38S1487.93,1283.76,1433.4,1184.84Z",
    transform: "translate(-283.73 -142.21)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1345.09,1466.83q-3.78,2.31-7.69,4.46c-.88.49-1.76,1-2.64,1.43-2,1.07-4,2.11-6.07,3.12-97.39,47.83-216.18,11.12-269.13-84.92-50.5-91.61-23.36-205.08,59.51-264.66a207,207,0,0,1,20.87-13.19c2.62-1.44,5.26-2.83,7.92-4.14s5.18-2.51,7.79-3.67a204.67,204.67,0,0,1,61.39-16.5,204.63,204.63,0,0,1,200.74,104.69C1470.87,1289.77,1438.16,1410.22,1345.09,1466.83Z",
    transform: "translate(-283.73 -142.21)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1240.1,1480.72a186.59,186.59,0,1,1,89.69-23.23A186.89,186.89,0,0,1,1240.1,1480.72Zm-153.71-101.83a175.22,175.22,0,1,0-14.87-133.28A174.07,174.07,0,0,0,1086.39,1378.89Z",
    transform: "translate(-283.73 -142.21)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1330,1312.1c-.4-1-.83-2-1.27-2.94a53.62,53.62,0,0,0-12.4-17.72,55.27,55.27,0,0,0-19.53-11.49,93.48,93.48,0,0,0-24.81-4.66q-13.7-.84-29.8-.39a143.49,143.49,0,0,1-17-.34,42.57,42.57,0,0,1-12-2.62,21.1,21.1,0,0,1-8-5.42,28.56,28.56,0,0,1-5.08-8.38,31.14,31.14,0,0,1-2.31-9.83,21.12,21.12,0,0,1,1.46-9.25,22.49,22.49,0,0,1,5.7-8.07,33.11,33.11,0,0,1,10.43-6.35q12-4.87,22.34.21t16.89,21.14l41.67-16.92a77.94,77.94,0,0,0-13.64-22.62,58.47,58.47,0,0,0-40.85-20.15,77.28,77.28,0,0,0-25.14,2.57l-11.8-29.06-23.07,9.37,11.64,28.65a86.49,86.49,0,0,0-21.18,15.07,64.72,64.72,0,0,0-13.34,18.61,51.75,51.75,0,0,0-4.91,21,56,56,0,0,0,4.4,22.39q5.33,13.13,13.73,20.79a54.57,54.57,0,0,0,19.5,11.42,92.51,92.51,0,0,0,24.83,4.5,291.75,291.75,0,0,0,29.87,0,109.39,109.39,0,0,1,16.25.11,42.5,42.5,0,0,1,11.91,2.64,22.55,22.55,0,0,1,8.34,5.66,30.68,30.68,0,0,1,5.61,9.27,25.51,25.51,0,0,1,2,9.87,21.06,21.06,0,0,1-2.22,9.41,26.65,26.65,0,0,1-6.62,8.31,39.86,39.86,0,0,1-11.19,6.56,47.92,47.92,0,0,1-12.23,3.18,28.06,28.06,0,0,1-12.34-1.23,28.81,28.81,0,0,1-11.26-7.29q-5.25-5.27-9.11-14.78l-41.66,16.92q6.51,16.05,16.39,25.47a59,59,0,0,0,21.58,13.46,66,66,0,0,0,24.53,3.54,104.07,104.07,0,0,0,25.26-4.18l10.76,26.52,22.92-9.31-10.82-26.64a92.39,92.39,0,0,0,21.39-14.93,62.87,62.87,0,0,0,12.91-16.86c.25-.48.5-1,.73-1.47a51.35,51.35,0,0,0,5-20.91A56.33,56.33,0,0,0,1330,1312.1Z",
    transform: "translate(-283.73 -142.21)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1086.71,572.17c.62-2.5-54.47,24.91-57.27,28-25.84,28.67-18.47,66.07-3.68,66.43,9.48.23,7.64,16,7.64,16L1139,637.91S1126.32,563.73,1086.71,572.17Z",
    transform: "translate(-283.73 -142.21)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1099.72,578s3.77-41.15-42.21-41.15c0,0,13.94,3.78,21.14,11.33,0,0-29.32-17.21-61.24,9.24s-12.08,92.81-21.79,105.41-47.5,15.12-42.88,55.85,120,91.75,112.54,125.46c0,0,45.2-66.44,12.88-96.76,0,0,15.75,14.83,17.36,32.47,0,0,4.27-34.43-17.64-45.45-19.39-9.74-35.27-45.39-33.59-51.76S1099.72,578,1099.72,578Z",
    transform: "translate(-283.73 -142.21)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1058,771.57c-7.09-34.14-51.37-44.73-72.31-16.85a36.93,36.93,0,0,0-7.28,17.94c-4.79,38.76,57.18,196.62,66.06,210.91,16.15,26,111.29,115.23,111.29,115.23l17.53-10.63s-67.48-114.24-77.93-124.93C1083.25,950.88,1071.43,836.4,1058,771.57Z",
    transform: "translate(-283.73 -142.21)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1149.06,1088.22s25.59-16.8,35.28-15.72,37.72,9.15,38.07,13.27-31.25,6.7-33.37,9-23.56,16.57-31.33,12.08S1149.06,1088.22,1149.06,1088.22Z",
    transform: "translate(-283.73 -142.21)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M970.56,1467.82l-22.86-3.36s-76.87-61.09-88.31-175.07a204,204,0,0,1-.55-35.24,6.16,6.16,0,0,0-.8-3.89l0,0c-2.46-3.77-8.59-13.22-16.88-26.66-8.17-13.24-22.15-38.27-37.54-66.35-27.71-50.58-60-111.07-71.05-130.34-35.27-61.4-18.27-102.69-18.27-102.69s98.38-9.72,125.34-33.31l9.71,15s21.32,94.37,20.31,94.81q1.58,4.8,3.2,9.8c16.82,51.92,36.17,116.82,46.72,169.67,5.93,29.74,9.07,55.65,7.39,73.3-.58,6.06.12,15.37,1.74,26.86C938.21,1348,970.56,1467.82,970.56,1467.82Z",
    transform: "translate(-283.73 -142.21)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1018.52,1496.74H923.14s-2.29-14.54,2.69-25.57c4.78-10.58,11.58-10.91.87-27.5,6.06,6.24,25.55,8.82,39.34,7,1.68,2.74,10.89,21.12,16.53,25.17C988.8,1480.28,1016.6,1478.69,1018.52,1496.74Z",
    transform: "translate(-283.73 -142.21)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M872.84,1010.46c-8.33,46-28,122.42-69.24,146.76-27.71-50.58-60-111.07-71.05-130.34-35.27-61.4-18.27-102.69-18.27-102.69s98.38-9.72,125.34-33.31l9.71,15s21.32,94.37,20.31,94.81Q871.22,1005.46,872.84,1010.46Z",
    transform: "translate(-283.73 -142.21)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1047.76,750.39s13.49,14,19.65,30.82c0,0-21.51,61.78-71.79,69.52C995.62,850.73,1035.4,750.37,1047.76,750.39Z",
    transform: "translate(-283.73 -142.21)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M806,931.29l.32-17.84C770.73,917.93,683.73,871,683.73,871s-37.19,24.73-42.27,95.35c-2.49,34.48-18.21,180.26-20,223.79-.63,15.78-.84,27-.91,31.54,0,0,0,0,0,0a6.17,6.17,0,0,1-1.51,3.67,204.13,204.13,0,0,0-19.26,29.52c-54.23,100.9-25.87,238-25.87,238l12.6-3.2s45.85-142.14,75.82-203.62c5.09-10.43,9.71-18.54,13.58-23.23,11.27-13.69,23.15-36.93,34.86-64.91,22.14-52.88,43.63-122.67,59-176.7C770.87,1021.45,806,931.29,806,931.29Z",
    transform: "translate(-283.73 -142.21)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1013.93,812.23c-58.1-13.33-21-95-17.61-93.54,8-1.64,25.73-15.78,41.55-43.38l2.13,1.85,35.69,31.29s-8.25,12.17-15.19,24.09c-5.42,9.33-10,18.52-9.3,21.68C1054.07,756.48,1029.43,815.79,1013.93,812.23Z",
    transform: "translate(-283.73 -142.21)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1075.69,708.46s-8.26,12.15-15.19,24.08c-22.19-13.67-22.21-41.14-20.5-55.37Z",
    transform: "translate(-283.73 -142.21)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1076.68,724.13s-53.87-30-34.69-63.24,25.15-59.53,60.36-41.8,34.51,34.25,30.8,46.91S1091.18,731.07,1076.68,724.13Z",
    transform: "translate(-283.73 -142.21)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1142.25,646.6c-2.46-14.77-10-16.18-15.2-15.19-19.89-32.9-52.39-20.06-52.39-20.06-17.36,21.78-42.46,25.5-42.46,25.5s6.25,11.63,32,18.83c7.86,2.2,16.79.87,25.4-2a143.82,143.82,0,0,1-36.55,13.78c33.94,3.11,66.23-27.93,69.58-31.24,1.57,4.8,4.32,14.87,2.67,22.23-2.23,10-11.11,28.12-5.69,30.47C1119.62,688.89,1146,668.75,1142.25,646.6Z",
    transform: "translate(-283.73 -142.21)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M649.81,1496.74H554.43s-2.29-14.54,2.7-25.57c4.77-10.58,12.25-15.39,10.46-28.19,6.06,6.24,15.93,13.23,29.72,11.37,1.69,2.74,10.91,17.4,16.55,21.45C620.09,1480.28,647.89,1478.69,649.81,1496.74Z",
    transform: "translate(-283.73 -142.21)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1020.77,877c-12.27,4.28-29.5,6.62-47.12,8.54-25.08,2.74-51,4.61-64.53,10-5,2-8.26,4.41-9.29,7.52C894,920.72,868,948,868,948,702,940.44,683.73,871,683.73,871,795.46,741.05,984.66,703.44,984.66,703.44s13.51-5.73,47.54,21.31c22.71,18.06,19.72,25,19.72,25S1056.89,864.36,1020.77,877Z",
    transform: "translate(-283.73 -142.21)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M973.65,885.5c-25.08,2.74-51,4.61-64.53,10-5.55-82.83,33.54-145.13,33.54-145.13S968.16,854.16,973.65,885.5Z",
    transform: "translate(-283.73 -142.21)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M999.46,734.36s-62.85,6.21-67.89,47,60.26,207.2,69.61,222.26c17,27.42,117.28,121.42,117.28,121.42l18.48-11.2s-71.11-120.38-82.12-131.65C1037.53,964.56,1020.75,748.51,999.46,734.36Z",
    transform: "translate(-283.73 -142.21)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M933.38,806c.17.92,58,18.89,95.24,0,0,0,8-85.89-36.48-81.23s-70.76,18.66-71.88,39.93S933.38,806,933.38,806Z",
    transform: "translate(-283.73 -142.21)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1112.75,1113.15s22.55-20.7,32.28-21.2,38.71,3,39.71,7-29.75,11.64-31.48,14.2-20.59,20.15-29,17S1112.75,1113.15,1112.75,1113.15Z",
    transform: "translate(-283.73 -142.21)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesA);
export default __webpack_public_path__ + "static/media/sales-a.9e2b6b0531134b15595606469f9e5dac.svg";
export { ForwardRef as ReactComponent };